import { useEffect, useMemo, useState } from "react";
import { backgroundImages } from "../backgrounds";

const INTERVAL_MS = 20000;
const TRANSITION_MS = 2000;

const BackgroundSlideshow = ({
  images = backgroundImages,
  intervalMs = INTERVAL_MS,
}: {
  images?: string[];
  intervalMs?: number;
}) => {
  const [index, setIndex] = useState(0);

  const slides = useMemo(() => {
    if (images.length > 0) return images;
    return [];
  }, [images]);

  // Preload images in the background so they are ready before fading in.
  useEffect(() => {
    slides.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, [slides]);

  useEffect(() => {
    if (slides.length <= 1) return;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [slides.length, intervalMs]);

  if (slides.length === 0) return null;

  return (
    <div className="bg-slideshow" aria-hidden="true">
      {slides.map((src, i) => (
        <div
          key={src}
          className={
            "bg-slide" + (i === index ? " bg-slide--active" : "")
          }
          style={{
            transitionDuration: `${TRANSITION_MS}ms`,
          }}
        >
          <div
            className="bg-slide-image"
            style={{ backgroundImage: `url(${src})` }}
          />
        </div>
      ))}
      <div className="bg-overlay" />
    </div>
  );
};

export default BackgroundSlideshow;
